import React from "react"
import FormInvestorPayment from "./Form"

export default function CreateInvestorPayment() {
  return <FormInvestorPayment />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Payments/Create.js